/**
 * Фільтр і поступове показування карток у блоці «Портфоліо».
 *
 * Перенесено з концепту (архів /work/), але прив'язка тепер до класу блока, а
 * не до id — блок може стояти на сторінці не один, і id задає редактор.
 * Фільтрація клієнтська: усі картки вже в DOM разом із data-type, тож перемикання
 * миттєве й не коштує запиту.
 */
(function () {
  var FALLBACK_STEP = 6;

  document.querySelectorAll('.phpdev-work').forEach(function (root) {
    var grid = root.querySelector('.folio');
    if (!grid) return;

    // Крок беремо з розмітки (data-step від PHPDEV_WORK_STEP): PHP за тим самим
    // числом вирішує, чи взагалі виводити кнопку, тож дві копії розійшлися б.
    var STEP = parseInt(root.dataset.step, 10) || FALLBACK_STEP;

    var chips = [].slice.call(root.querySelectorAll('.chip-btn'));
    var cards = [].slice.call(grid.children);
    var more  = root.querySelector('.folio-load');
    var count = root.querySelector('.folio-count');
    if (!chips.length && !more) return;

    var type = 'all';
    var shown = STEP;

    function matches(c) {
      // data-type може містити кілька слагів через пробіл: кейс буває
      // одночасно, наприклад, «Каталоги» і «Підтримка».
      if (type === 'all') return true;
      return (c.dataset.type || '').split(/\s+/).indexOf(type) !== -1;
    }

    function apply() {
      var seen = 0, total = 0;
      cards.forEach(function (c) {
        if (!matches(c)) { c.hidden = true; return; }
        total++;
        c.hidden = seen >= shown;
        if (!c.hidden) seen++;
      });
      if (more) more.hidden = seen >= total;
      if (count) count.textContent = count.dataset.tpl
        ? count.dataset.tpl.replace('%1', seen).replace('%2', total)
        : seen + ' / ' + total;
    }

    chips.forEach(function (b) {
      b.addEventListener('click', function () {
        chips.forEach(function (x) { x.classList.toggle('is-on', x === b); });
        type = b.dataset.f;
        shown = STEP;
        apply();
      });
    });

    if (more) {
      more.addEventListener('click', function () { shown += STEP; apply(); });
    }

    // Прийшли зі сторінки типу сайту: /portfolio/#type-<slug> — одразу відкрити
    // таб цього типу. Немає такого табу (тип без кейсів) — лишаємо «Усі».
    var fromHash = (location.hash.match(/^#type-([\w-]+)$/) || [])[1];
    var preset = fromHash && chips.filter(function (b) { return b.dataset.f === fromHash; })[0];
    if (preset) {
      chips.forEach(function (x) { x.classList.toggle('is-on', x === preset); });
      type = preset.dataset.f;
    }

    apply();
  });
})();
